module.exports = __webpack_public_path__ + "static/media/video-mobile.9184dbb5.webp";